const URLS = {
  APPLE_APP_STORE_URL: 'https://apps.apple.com/se/app/husqvarna-fleet-services/id6692631689',
  GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.husqvarna.hfshybrid',
  GOOGLE_PLAY_STORE_GATEWAY_URL:
    'https://play.google.com/store/apps/details?id=com.husqvarna.gateway',
  INSTALL_SENSOR_VIDEO_URL: 'https://youtu.be/jiueedDP_OI',
  GOOGLE_CHROME_URL: 'https://www.google.com/chrome',
  FIREFOX_URL: 'https://www.mozilla.org/firefox/',
  FLEET_INFO_SITE_URL: 'https://www.husqvarna.com/fleet-services/',
  GOOGLE_MAPS_URL: 'https://maps.googleapis.com/maps/api/js?key=#GOOGLE_MAPS_API_KEY#',
  FLEET_SERVICES_PRICING_URL: 'https://www.husqvarna.com/fleet-services/',
  SUPPORT_URL: 'https://www.husqvarna.com/appsupport',
  PRIVACY_NOTICE_URL: 'https://privacyportal.husqvarnagroup.com/{lang}/privacy-notice/',
  PRIVACY_NOTICE_LEGACY_URL: 'https://www.husqvarna.com/{lang}/privacy-notice/',
  SHAREABLE_GOOGLE_MAPS_URL:
    'https://www.google.com/maps/search/?api=1&query={latitude},{longitude}',
  GOOGLE_PLACES_API_BASE: 'https://places.googleapis.com/v1/places',
  YOUTUBE_API: 'https://www.googleapis.com/youtube/v3',
  HUSQVARNA_US_SHOP_SENSOR:
    'https://shop.husqvarna.com/us/husqvarna-fleet-machine-sensor-5pcs-584918906#',
  RECAPTCHA_ABOUT: 'https://www.google.com/recaptcha/about/',
  DEALERS_INFO_SITE_URL: 'https://husqvarna.com/dealers',
  UPTIME_CENTER_APP_URL: 'https://uptimecenter.husqvarna.com',
};

export default URLS;
